import { DatePipe, Location, NgClass, NgStyle } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { addDays, subDays } from 'date-fns';
import { Guid } from 'guid-typescript';
import { IndusEventAction } from 'src/app/models/indus-event-action';
import {
  PrepareScheduleTaskFilter,
  ScheduleTaskFilter,
} from 'src/app/models/scheduleTask-filter.model';
import { ReducedScheduleTask } from 'src/app/models/scheduleTask.model';
import { ScheduleTaskFilterToShow } from 'src/app/models/ScheduleTaskFilterToShow';
import { UserModel } from 'src/app/models/user.model';
import { UserManagementService } from 'src/app/services/user-management.service';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { ContainerAnimations } from 'src/app/shared/animations/container-animation';
import { IndCalendarComponent, calendarRange, calendarSession } from 'src/app/shared/components/calendar/ind-calendar/ind-calendar.component';
import { UserService } from 'src/app/shared/services/user.service';
import { actions } from 'src/assets/data/calendar-config';
import { taskStatuses } from 'src/assets/data/task-statuses';
import { ScheduleDetailComponent } from '../schedule-detail/schedule-detail.component';
import { JobModel } from 'src/app/models/job.model';
import { thirdPartyApp } from 'src/assets/data/third-party-app';
import { ScheduleTasksFilterComponent } from '../schedule-tasks-filter/schedule-tasks-filter.component';
import { AppCommunicationService } from 'src/app/shared/services/app-communication.service';
import { ActivatedRoute } from '@angular/router';
import { SharedServices } from 'src/app/shared/services/shared.service';
import { PaginatedNonScheduledTasks } from 'src/app/models/paginated-non-scheduled-task.model';
import {
  MatPaginator,
  MatPaginatorIntl,
  PageEvent,
} from '@angular/material/paginator';
import { SignalRService } from 'src/app/services/signal-r.service';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { TagComponent } from '../../tag/tag.component';
import { CalendarCommonService } from 'src/app/shared/services/ind-calendar.service';
import { Subject, finalize, takeUntil } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { IndCalendarComponent as IndCalendarComponent_1 } from '../../../shared/components/calendar/ind-calendar/ind-calendar.component';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { IgnoredContractors, ignoredContractorsOf, isIgnoredContractor } from './ignored-contractors';

import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-schedule-tasks',
    templateUrl: './schedule-tasks.component.html',
    styleUrls: ['./schedule-tasks.component.scss'],
    animations: [ContainerAnimations.height],
    imports: [MatProgressSpinner, ScheduleTasksFilterComponent, TagComponent, NgClass, IndCalendarComponent_1, MatCard, MatCardContent, MatCardTitle, NgStyle, MatIcon, MatPaginator, DatePipe, EmptyStateComponent]
})
export class ScheduleTasksComponent implements OnInit, AfterViewInit {
  private readonly configSvc = inject(ConfigurationService);
  private readonly workloadsService = inject(WorkloadsService);
  private readonly workTaskSvc = inject(WorkTaskService);
  datepipe = inject(DatePipe);
  private readonly userSvc = inject(UserManagementService);
  usrSvc = inject(UserService);
  private readonly location = inject(Location);
  private readonly appCommunicationService = inject(AppCommunicationService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly sharedService = inject(SharedServices);
  private readonly calendarDataService = inject(CalendarCommonService);
  private readonly paginatorIntl = inject(MatPaginatorIntl);
  signalRService = inject(SignalRService);

  @ViewChild(IndCalendarComponent, { static: false })
  indCalendarComponent!: IndCalendarComponent;
  @ViewChild(ScheduleTasksFilterComponent, { static: false })
  scheduleTasksFilterComponent!: ScheduleTasksFilterComponent;
  @ViewChild(TagComponent, { static: false }) tagComponent!: TagComponent;
  modal: any = ScheduleDetailComponent; //Modal to show after action
  thirdPartyAppList = thirdPartyApp;
  private readonly destroy$ = new Subject<void>();

  isVisible: boolean = false;
  tagIsVisible: boolean = false;
  allEvents: any[] = [];
  allPendingContact: any[] = [];

  //Actions within each work task
  actions: IndusEventAction[] = [];
  selected: Guid = Guid.createEmpty();
  notScheduledTask: ReducedScheduleTask[] = [];
  notScheduledTaskwithoutContact: ReducedScheduleTask[] = [];
  statusList = taskStatuses;
  creatorNames: UserModel[] = [];
  showNotScheduledTask: boolean = true;
  // With the browser offset (e.g. -03:00): without it the API (UTC) read the range 3 hours off.
  format = 'yyyy-MM-ddTHH:mm:ssZZZZZ';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalCount = 0;
  pageSize = 30;

  pageNumber = 1;
  loading = 1;

  filter: ScheduleTaskFilter = {
    id: null as unknown as string,
    from: null as unknown as string,
    to: null as unknown as string,
    description: null as unknown as string,
    groupType: [],
    taskType: [],
    clientName: [],
    creationDateFrom: null as unknown as string,
    creationDateTo: null as unknown as string,
    contractor: null as unknown as any,
    taskStatus: [],
    owner: [],
    isPaidLabor: null as unknown as string,
    productId: null as unknown as any,
    pointOfSaleId: null as unknown as any,
    franchiseId: null as unknown as any,
    includeCanceled: false as boolean,
    onlyHasPendingContact: false as boolean,
    includePostponed: false as boolean,
    includeBudgeted: false as boolean,
    tags: [],
  };

  mostrarFiltro: ScheduleTaskFilterToShow = {
    id: null as unknown as string,
    description: null as unknown as string,
    grouping: [],
    clientName: [],
    creationDateFrom: null as unknown as Date,
    creationDateTo: null as unknown as Date,
    contractors: [],
    ignoredContractors: [],
    taskStatus: [],
    owner: [],
    isPaidLabor: null as unknown as string,
    productName: [],
    sealesPointsNames: [],
    tags: [],
  };
  showFilters = false;
  filterCount: number = 0;
  // "Ignorar prestador": kept out of `filter` because the API has no such parameter; the calendar hides them.
  ignoredContractors: IgnoredContractors = ignoredContractorsOf([]);

  @ViewChild('scheduledContent', { static: false })
  scheduledContent!: ElementRef;
  @ViewChild('notScheduledContent', { static: false })
  notScheduledContent!: ElementRef;
  lastUpdate: Date = new Date();

  constructor() {
    this.initSignalRService(); //Init SignalR service for Task updates

    this.activatedRoute.queryParams.subscribe({
      next: (param) => {
        if (param.taskId) {
          this.workloadsService.getById(param.taskId).subscribe({
            next: (st) => {
              this.scheduleTask(st, 'view');
            },
          });
        }
      },
    });

    this.appCommunicationService.executeToggleVisibility$.subscribe(() => {
      this.toggleVisibility();
    });

    this.appCommunicationService.executeToggleTagVisibility$.subscribe(() => {
      this.toggleTagVisibility();
    });

    this.setPaginatorLabels();
  }

  ngOnInit(): void {
    this.appCommunicationService.displayOpenFilterButton(true);
    this.getStatusList();
    // The range the calendar will show: the month/week/day last viewed in this session, else the current month.
    const range = calendarRange(calendarSession.view ?? 'month', calendarSession.viewDate ?? new Date());
    let daysBefore = range.from.getDay() === 0 ? 0 : range.from.getDay();
    let daysAhead = 6 - (range.to.getDay() === 0 ? 0 : range.to.getDay());

    this.filter.from = this.datepipe.transform(
      subDays(range.from, daysBefore),
      this.format
    ) as unknown as string;
    this.filter.to = this.datepipe.transform(
      addDays(range.to, daysAhead),
      this.format
    ) as unknown as string;

    this.actions.push({
      label: actions.info.label,
      code: actions.info.code,
      a11yLabel: actions.info.a11yLabel,
      onClick: (): void => {},
    });
    this.getOwners();
  }

  ngAfterViewInit(): void {
    this.activatedRoute.fragment
      .pipe(takeUntil(this.destroy$))
      .subscribe((fragment) => {
        if (fragment) {
          document
            .getElementById(fragment)
            ?.scrollIntoView({ behavior: 'instant', block: 'center' });
        }
      });
  }

  initSignalRService() {
    this.signalRService
      .startConnection(this.configSvc.workloadsApiUrl, 'hubs/schedule')
      .then(() => {
        this.listenTaskUpdates();
        // Changes made while the connection was down never arrive: reload what is on screen.
        this.signalRService.hubConnection?.onreconnected(() => {
          this.getScheduleTasks();
          this.getPaginatedNotScheduledTasks();
        });
      });
  }

  listenTaskUpdates() {
    this.signalRService.hubConnection?.on('ScheduleChannel', (data: any) => {
      this.proccessSignalRData(data);
    });
  }

  proccessSignalRData(data: ReducedScheduleTask) {
    // Check if scheduled and remove from calendar
    let currentIndex = this.allEvents.findIndex((x) => x.id == data.id);
    if (currentIndex != -1) {
      this.allEvents.splice(currentIndex, 1);
    }

    // Check if not scheduled and remove from list
    currentIndex = this.notScheduledTask.findIndex((x) => x.id == data.id);
    if (currentIndex != -1) {
      this.notScheduledTask.splice(currentIndex, 1);
    }

    // Backend will return null if is the wrong point of sale
    this.workloadsService.getById(data.id.toString()).subscribe((task) => {
      // apply filters and validate task details
      if (!task || !this.applyFilters(task)) {
        this.applyChanges();
        return;
      }

      // Update lists with new task data
      if (data.schudeledDate) {
        if (!isIgnoredContractor(task, this.ignoredContractors)) {
          this.allEvents.push(this.createEvent(data));
        }
      } else {
        if (currentIndex != -1) {
          this.notScheduledTask.splice(currentIndex, 0, data); // add to the same place it was removed
        } else {
          this.notScheduledTask.unshift(data); // new task, add at start of the list
        }
      }

      // update views
      this.applyChanges();
    });
  }

  applyChanges() {
    this.paginator.pageIndex = this.pageNumber ? this.pageNumber - 1 : 0;
    this.updateCalendarEvents(this.allEvents);
    this.getPaginatedNotScheduledTasks();
    this.lastUpdate = new Date();
  }

  applyFilters(data: any): boolean {
    // Same scope as the API (SetFranchise): the user's franchise, else the franchise picked in the filter, else
    // none (Indusplast's own tasks). The old check used user.franchise from the ID token: an admin viewing a
    // franchise, or a franchise user whose ID token lacks the claim, dropped the live updates of the tasks on screen.
    const scope = this.usrSvc.franchise ?? this.usrSvc.user?.['franchise'] ?? this.filter.franchiseId ?? null;
    if ((data.franchiseId ?? null) != scope) return false;

    if (
      this.filter.groupType.length > 0 &&
      !this.filter.groupType.includes(data.jobGroupId)
    )
      return false;
    if (
      this.filter.taskType.length > 0 &&
      !this.filter.taskType.includes(data.taskTypeId)
    )
      return false;
    if (
      this.filter.contractor.length > 0 &&
      !this.filter.contractor.includes(data.contractorId)
    )
      return false;
    if (
        this.filter.clientName.length > 0 &&
        !this.filter.clientName.some((x) =>
          x.toUpperCase().includes(data.clientName.toUpperCase())
        )
      )
        return false;
    if (
      this.filter.taskStatus.length > 0 &&
      !this.filter.taskStatus.includes(data.status)
    )
      return false;
    if (this.filter.owner.length > 0 && !this.filter.owner.includes(data.owner))
      return false;
    if (
      this.filter.productId.length > 0 &&
      !this.filter.productId.includes(data.productId)
    )
      return false;
    if (this.filter.franchiseId && this.filter.franchiseId != data.franchiseId)
      return false;

    return true;
  }

  getFilterCount() {
    let filterCount = 0;

    let filtersArray = Object.entries(this.filter);
    for (let [key, value] of filtersArray) {
      if (
        value !== undefined &&
        value !== null &&
        !(
          key == 'from' ||
          key == 'to' ||
          key == 'franchiseId' ||
          key == 'includeCanceled' ||
          key == 'onlyHasPendingContact' ||
          key == 'includePostponed' ||
          key == 'includeBudgeted'
        )
      ) {
        if (typeof value === 'string' && value.trim() !== '') {
          filterCount++;
        } else if (Array.isArray(value) && value.length > 0) {
          filterCount += value.length;
        } else if (typeof value === 'boolean') {
          filterCount++;
        }
      }
    }

    return filterCount + this.ignoredContractors.ids.length;
  }

  updateFilterCount() {
    let count = 0;

    let filtersArray = Object.entries(this.filter);
    for (let [key, value] of filtersArray) {
      if (
        value !== undefined &&
        value !== null &&
        !(key == 'from' || key == 'to' || key == 'franchiseId')
      ) {
        if (typeof value === 'string' && value.trim() !== '') {
          count++;
        } else if (Array.isArray(value) && value.length > 0) {
          count += value.length;
        } else if (typeof value === 'boolean') {
          count++;
        }
      }
    }

    this.filterCount = count + this.ignoredContractors.ids.length;
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  async resizeNotScheduledContent() {
    await new Promise((resolve) => setTimeout(resolve, 0));
    const div1Height = this.scheduledContent.nativeElement.offsetHeight;
    this.notScheduledContent.nativeElement.style.height = div1Height + 'px';
  }

  toggleVisibility() {
    this.isVisible = !this.isVisible;

    if (this.tagIsVisible) {
      this.tagIsVisible = false;
      this.tagComponent.cancelTagToEdit();
    }
  }

  // Esc closes the open filters or tags panel (they are non-modal overlays).
  // An Esc that already closed a Material overlay inside them (select,
  // datepicker, autocomplete) arrives with defaultPrevented and must only
  // close that overlay.
  @HostListener('document:keydown.escape', ['$event'])
  closePanelsOnEscape(event: KeyboardEvent) {
    if (event.defaultPrevented) {
      return;
    }
    if (this.tagIsVisible) {
      this.toggleTagVisibility();
    }
    if (this.isVisible) {
      this.toggleVisibility();
    }
  }

  toggleTagVisibility() {
    this.tagIsVisible = !this.tagIsVisible;

    if (!this.tagIsVisible) {
      this.tagComponent.cancelTagToEdit();
    }

    if (this.isVisible) {
      this.isVisible = false;
    }
  }

  getOwners() {
    this.userSvc.getUsers().subscribe((data: UserModel[]) => {
      this.creatorNames = data;
    });
  }

  getStatusList() {
    this.workloadsService.getStatusList().subscribe((data) => {
      for (let key of Object.keys(data)) {
        let val = data[key];
        this.statusList.forEach((x) => {
          if (x.code == val) {
            x.value = Number(key);
            return;
          }
        });
      }
    });
  }

  //esto es para validar los botones
  validateNotStatus(id: any, code: string) {
    let status = taskStatuses.find((x) => x.value == id);
    return status?.code != code;
  }

  getStatusByCode(code: string) {
    this.statusList.find((x) => x.code == code);
  }

  getScheduleTasks() {
    this.workloadsService
      .getReducedScheduleTasks(this.filter)
      .pipe(finalize(() => this.loading--))
      .subscribe({
      next: (data: ReducedScheduleTask[]) => {
        this.indCalendarComponent.events = [];
        this.allEvents = data
          .filter((st) => !isIgnoredContractor(st, this.ignoredContractors))
          .map((st) => this.createEvent(st));
        this.updateCalendarEvents(this.allEvents);

        this.resizeNotScheduledContent();
        this.lastUpdate = new Date();
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  updateCalendarEvents(events: any[]) {
    if (this.indCalendarComponent) {
      this.calendarDataService.dailyTaskData = events;
      this.indCalendarComponent.setEvents(events);
      this.indCalendarComponent.refresh.next();
    }
  }

  scheduleTask(st: ReducedScheduleTask, action: string): void {
    this.indCalendarComponent.dialogAction(action, this.createEvent(st));
  }

  createEvent(st: ReducedScheduleTask): any {
    let shortTitle = `${st.jobGroup}, ${st.taskType} - ${st.clientName} - ${st.clientAddress}`;
    let title = `${shortTitle}, ${st.clientAddress}`;

    this.actions.forEach((a) => {
      if (a.code == 'Info') {
        a.label = a.label.replace('TITLE', title);
      }
    });

    return {
      id: st.id,
      start: new Date(st.schudeledDate),
      title: shortTitle,
      color: this.statusList.find((x) => x.value == st.status)?.eventColor,
      event: { data: st, taskStatuses: this.statusList },
    };
  }

  getPaginatedNotScheduledTasks() {
    const filterNotScheduled = {
      ...this.filter,
      from: null as unknown as string,
      to: null as unknown as string,
    };
    this.loading++;

    this.workloadsService
      .getPaginatedNonScheduledTasks(
        filterNotScheduled,
        this.pageNumber,
        this.pageSize
      )
      .pipe(finalize(() => this.loading--))
      .subscribe({
        next: (data: PaginatedNonScheduledTasks) => {
          this.notScheduledTask = data.tasks;
          this.totalCount = data.totalCount;
          this.paginator.pageIndex = this.pageNumber - 1;
        },
        error: (err) => {
          console.error('Error al cargar tareas no agendadas:', err);
        },
      });
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.getPaginatedNotScheduledTasks();
  }

  // Fired by the calendar when the view (month/week/day) or the date range changes.
  closeOpenMonthViewDay(event: any) {
    // The tags panel is a transient overlay: a new view or range closes it (Esc still closes it too).
    if (this.tagIsVisible) {
      this.toggleTagVisibility();
    }

    let daysBefore = event.from.getDay() === 0 ? 0 : event.from.getDay();
    let daysAhead = 6 - (event.to.getDay() === 0 ? 0 : event.to.getDay());

    this.filter.from = this.datepipe.transform(
      subDays(event.from, daysBefore),
      this.format
    ) as unknown as string;
    this.filter.to = this.datepipe.transform(
      addDays(event.to, daysAhead),
      this.format
    ) as unknown as string;

    this.getScheduleTasks();
  }

  closeModalEvent(broadcast: any) {
    this.location.replaceState('/scheduleTasks');
  }

  getStatusColor(status: number): any {
    return this.statusList.find((x) => x.value == status)?.eventColor;
  }

  getStatusSelectedColor(status: any) {
    return this.statusList.find((x) => x.value == status)?.eventColor.primary;
  }

  getStatusDescription(status: any) {
    return this.statusList.find((x) => x.value == status)?.name;
  }

  filterSchedule(preFilter: PrepareScheduleTaskFilter) {
    this.toShowFilter(preFilter);
    this.sharedService.selectedFranchise.subscribe((franchise) => {
      if (franchise != undefined && franchise != null) {
        this.filter.franchiseId = franchise.id;
      } else {
        this.filter.franchiseId = undefined;
      }
    });

    /* Map */
    this.filter.description = preFilter.description;
    this.filter.groupType = preFilter.groupType;
    this.filter.taskType = preFilter.taskType;
    this.filter.clientName = [...preFilter.clientName];
    this.filter.creationDateFrom = preFilter.creationDateFrom;
    this.filter.creationDateTo = preFilter.creationDateTo;
    this.filter.contractor = preFilter.contractors.map(({ id }) => id);
    this.ignoredContractors = ignoredContractorsOf(preFilter.ignoredContractors);
    this.filter.taskStatus = [...preFilter.taskStatus];
    this.filter.tags = [...preFilter.tags.map(({ id }) => id)];
    this.filter.owner = preFilter.owner;
    this.filter.isPaidLabor = preFilter.isPaidLabor?.toString();
    this.filter.productId = preFilter.products.map(({ id }) => id);
    this.filter.pointOfSaleId = preFilter.sealesPoints.map(({ id }) => id);
    this.filter.onlyHasPendingContact = preFilter.onlyHasPendingContact;
    this.filter.includeCanceled = preFilter.includeCanceled;
    this.filter.includePostponed = preFilter.includePostponed;
    this.filter.includeBudgeted = preFilter.includeBudgeted;

    this.getPaginatedNotScheduledTasks();
    this.getScheduleTasks();

    // Actualizar el conteo de filtros
    this.updateFilterCount();

    if (this.isVisible) {
      this.toggleVisibility();
    }

    if (this.tagIsVisible) {
      this.toggleTagVisibility();
    }
  }

  toShowFilter(preFilter: PrepareScheduleTaskFilter) {
    if (preFilter.groupType != null && preFilter.groupType.length > 0) {
      this.mostrarFiltro.grouping = [];
      this.workTaskSvc.getTaskGroups().subscribe((tasks) => {
        tasks.forEach((t) => {
          if (preFilter.groupType.find((x) => x == t.id)) {
            if (preFilter.taskType && preFilter.taskType.length > 0) {
              let auxSubCat: JobModel[] = [];

              this.workTaskSvc.getJobs(t.id).subscribe((tasksType) => {
                auxSubCat = tasksType.filter((tt) => {
                  return preFilter.taskType.some(
                    (selected) => selected === tt.id
                  );
                });
                this.mostrarFiltro.grouping.push({
                  groupName: t.description,
                  jobs: auxSubCat.map((j) => j.description),
                });
              });
            } else {
              this.mostrarFiltro.grouping.push({
                groupName: t.description,
                jobs: [],
              });
            }
          }
        });
      });
    } else {
      this.mostrarFiltro.grouping = [];
    }

    if (preFilter.clientName.length > 0) {
      this.mostrarFiltro.clientName = preFilter.clientName;
    } else {
      this.mostrarFiltro.clientName = [];
    }

    if (preFilter.contractors.length > 0) {
      this.mostrarFiltro.contractors = preFilter.contractors.map(
        ({ fullName }) => fullName
      );
    } else {
      this.mostrarFiltro.contractors = [];
    }
    this.mostrarFiltro.ignoredContractors = (preFilter.ignoredContractors ?? []).map(
      ({ fullName }) => fullName
    );
    if (preFilter.owner.length != 0) {
      let auxOwner: string[] = [];
      this.creatorNames.forEach((cn) => {
        let selected = preFilter.owner.find((x) => x == cn.id);
        if (selected) {
          auxOwner.push(cn.name);
        }
      });
      this.mostrarFiltro.owner = auxOwner;
    } else {
      this.mostrarFiltro.owner = [];
    }
    if (preFilter.taskStatus.length != 0) {
      let aux: string[] = [];
      this.statusList.forEach((sl) => {
        let selected = preFilter.taskStatus.find(
          (x) => x == sl.value.toString()
        );
        if (selected) {
          aux.push(sl.code);
        }
      });
      this.mostrarFiltro.taskStatus = aux;
    } else {
      this.mostrarFiltro.taskStatus = [];
    }

    if (preFilter.tags.length != 0) {
      let aux: string[] = [];
      preFilter.tags.forEach((t) => {
        aux.push(t.name);
      });
      this.mostrarFiltro.tags = aux;
    } else {
      this.mostrarFiltro.tags = [];
    }

    if (
      preFilter.creationDateFrom != null &&
      preFilter.creationDateTo != null
    ) {
      this.mostrarFiltro.creationDateFrom = new Date(
        preFilter.creationDateFrom
      );
      this.mostrarFiltro.creationDateTo = new Date(preFilter.creationDateTo);
    } else {
      this.mostrarFiltro.creationDateFrom = null;
      this.mostrarFiltro.creationDateTo = null;
    }

    if (preFilter.isPaidLabor != null) {
      if (preFilter.isPaidLabor) {
        this.mostrarFiltro.isPaidLabor = 'Mano de obra paga';
      } else {
        this.mostrarFiltro.isPaidLabor = 'Mano de obra no paga';
      }
    } else {
      this.mostrarFiltro.isPaidLabor = preFilter.isPaidLabor;
    }

    if (preFilter.products.length > 0) {
      this.mostrarFiltro.productName = preFilter.products.map(
        ({ name }) => name
      );
    } else {
      this.mostrarFiltro.productName = [];
    }

    if (preFilter.sealesPoints.length > 0) {
      this.mostrarFiltro.sealesPointsNames = preFilter.sealesPoints.map(
        ({ description }) => description
      );
    } else {
      this.mostrarFiltro.sealesPointsNames = [];
    }
  }

  getThirdPartyAppName(fromThirdPartyApp: number) {
    let thirdPartyAppName: any;
    thirdPartyAppName = this.thirdPartyAppList.find(
      (x) => x.id == fromThirdPartyApp
    )?.name;

    return thirdPartyAppName ?? '';
  }

  applyPendingContactStyle(task: ReducedScheduleTask): boolean {
    if (this.usrSvc.hasPermission('view:pendingContactFilter')) {
      return !task.hasClientContact;
    }
    return false;
  }

  setPaginatorLabels() {
    const getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize + 1;
      const endIndex = Math.min(startIndex + pageSize - 1, length);
      return `${startIndex} - ${endIndex} de ${length}`;
    };
    this.paginatorIntl.itemsPerPageLabel = '';
    this.paginatorIntl.nextPageLabel = 'Página siguiente';
    this.paginatorIntl.previousPageLabel = 'Página anterior';
    this.paginatorIntl.getRangeLabel = getRangeLabel;
  }

  ngOnDestroy(): void {
    this.appCommunicationService.displayOpenFilterButton(false);
  }
}
